export const listByIdNameDenominationNature = [
    {ID: 'All', NAME: 'All'},
    {ID: 'denomination', NAME: 'Denomination'},
    {ID: 'synonym', NAME: 'Synonym'},
    {ID: 'trade name', NAME: 'Trade name'},
    {ID: 'trade mark', NAME: 'Trade mark'},
];
